var _rect, _polygon, _polygon2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNorway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "37.547 85.333 24 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.547,
    y: 85.333,
    width: 24,
    height: 17,
    fill: "#d80027",
    strokeWidth: 0.048317
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    transform: "matrix(.046875 0 0 .049803 37.547 81.083)",
    points: "0 216.11 122.44 216.11 122.44 85.329 140.98 85.329 183.65 85.329 202.2 85.329 202.2 216.11 512 216.11 512 234.67 512 277.33 512 295.88 202.2 295.88 202.2 426.67 183.65 426.67 140.98 426.67 122.44 426.67 122.44 295.88 0 295.88 0 277.33 0 234.67",
    fill: "#fff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    transform: "matrix(.046875 0 0 .049803 37.547 81.083)",
    points: "183.65 85.329 183.65 234.67 512 234.67 512 277.33 183.65 277.33 183.65 426.67 140.98 426.67 140.98 277.33 0 277.33 0 234.67 140.98 234.67 140.98 85.329",
    fill: "#2e52b2"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorway);
export default __webpack_public_path__ + "static/media/norway.3da04afc6957980d0282465c03c3d0a7.svg";
export { ForwardRef as ReactComponent };